import { useEffect, useState, useContext } from "react";
import { getSheetValues } from "../../service/googlesheetService";
import { Card } from "./Feature";
import { Oval } from "react-loader-spinner";
import pngLogo from "../../assets/logo.svg";
import "./Tribu.css";
import { dataContext } from "../../Context";
import { ILoadingData, ILoadingValue } from "../../Interfaces";

const RANGE = "A3:B";
const SHEET = "Settings";

const Tribu = () => {
  const [data, setData] = useState<Array<string>>([]);
  const { loadingData, loadingDetail } = useContext(dataContext);

  //Fetch tribe's name
  const getNameTribe = async (storage: string): Promise<void> => {
    const response: Array<string> = await getSheetValues(storage, SHEET, RANGE);

    return setData(response);
  };

  useEffect(() => {
    const token = localStorage.getItem("idToken");
    if (token) {
      getNameTribe(token);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="tribu">
      <div className="HeaderLogin">
        <h2>Skill'Up</h2>
        <p className="catchPhrase">
          Explore tes forces et axes d’apprentissage pour progresser vers ton
          objectif.
        </p>
      </div>
      {loadingData ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            height: "27vh",
            zIndex: "100",
            margin: "40px",
          }}
        >
          <div
            style={{
              zIndex: "100",
            }}
          >
            <Oval
              ariaLabel="loading-indicator"
              wrapperStyle={{ zIndex: "100" }}
              height={100}
              width={100}
              strokeWidth={5}
              strokeWidthSecondary={3}
              secondaryColor="#FCA2AE"
              color="#FFFFFF"
            />
          </div>
          <div style={{ zIndex: "100", color: "#FFFFFF" }}>
            {Object.entries(loadingDetail as ILoadingData).map(
              (value: [string, ILoadingValue], index: number) => {
                return (
                  <div key={index}>
                    <p>
                      {value[1].title} : {value[1].value}
                    </p>
                  </div>
                );
              }
            )}
          </div>
        </div>
      ) : (
        <>
          <p className="chooseTribe">Sélectionne ta tribu</p>
          <ul className="tribe">
            {data.map((tribe, index) => (
              <div key={index} style={{ zIndex: "10" }}>
                <Card index={index} tribe={tribe} />
              </div>
            ))}
          </ul>
        </>
      )}

      <div className={loadingData ? "footer" : "footerTransition"}>
        <img className="logo" src={pngLogo} alt="logo Devoteam" />
      </div>
    </div>
  );
};

export default Tribu;
